module.exports = {"body":"<h2>jetzt runterladen</h2>\n<p>Also ran an die neue “Golden City-App”!\n<br>Tickets holen und dabei sein!\n<br><a href=\"https://apps.apple.com/de/app/golden-city-bremen/id1570219666\">Download für iOS</a><br>\n<a href=\"https://play.google.com/store/apps/details?id=de.neusta.ms.goldencity\">Download für Android</a></p>\n"}


//////////////////
// WEBPACK FOOTER
// ./tickets.sidebar.md
// module id = 1032
// module chunks = 0